import React from "react";
import PropTypes from "prop-types";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";

const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const gplxcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "sogplx",
    headerName: "Số GPLX",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "hanggplx",
    headerName: "Hạng GPLX",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "ngayhethan",
    headerName: "Ngày hết hạn",
    width: 190,
    headerAlign: "center",
  },
];
const gkskcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "donvicap",
    headerName: "Đơn vị cấp",
    width: 280,
    headerAlign: "center",
  },
  {
    field: "sogiayksk",
    headerName: "Số GKSK",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "ngayhethan",
    headerName: "Ngày hết hạn",
    width: 190,
    headerAlign: "center",
  },
];
const hdcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "sohdld",
    headerName: "Số hợp đồng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngay_batdau",
    headerName: "Ngày bắt đầu",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "ngay_ketthuc",
    headerName: "Ngày kết thúc",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "ten_loaihd",
    headerName: "Loại hợp đồng",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "trangthaihd",
    headerName: "Trạng thái",
    width: 210,
    headerAlign: "center",
  },
];
const thcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "sogcn",
    headerName: "Số GCN",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "thoihan",
    headerName: "Ngày hết hạn",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "donvicap",
    headerName: "Đơn vị cấp",
    width: 280,
    headerAlign: "center",
  },
];
const Capnhatlaixe = React.memo(function Capnhatlaixe(props) {
  const { laixe_id } = props;
  const [hoten, setHoten] = React.useState("");
  const [ngaysinh, setNgaysinh] = React.useState(dayjs());
  const [cmnd, setCmnd] = React.useState("");
  const [ngaycapcmnd, setNgaycapcmnd] = React.useState(dayjs());
  const [diachi, setDiachi] = React.useState("");
  const [sodienthoai, setSodienthoai] = React.useState("");
  const [giaypheplaixe, setGiaypheplaixe] = React.useState([]);
  const [giaykhamsuckhoe, setGiaykhamsuckhoe] = React.useState([]);
  const [hopdong, setHopdong] = React.useState([]);
  const [taphuannv, setTaphuannv] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getlaixetheoid = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixeid?id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHoten(data[0].hoten);
        let [day, month, year] = data[0].ngaysinh.split("/");
        setNgaysinh(dayjs(year + "-" + month + "-" + day));
        setCmnd(data[0].cmnd);
        let [day1, month1, year1] = data[0].ngaycapcmnd.split("/");
        setNgaycapcmnd(dayjs(year1 + "-" + month1 + "-" + day1));
        setDiachi(data[0].diachi);
        setSodienthoai(data[0].sodienthoai);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getgiayphep = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixegplxtheolxid?laixe_id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setGiaypheplaixe(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getgiaykhamsuckhoe = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixegksktheolaixeid?laixe_id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setGiaykhamsuckhoe(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gethopdonglaodong = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixehdldtheolaixeid?laixe_id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHopdong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gettaphuannghiepvu = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getgcnlaixeid?laixe_id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTaphuannv(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getlaixetheoid();
    getgiayphep();
    getgiaykhamsuckhoe();
    gethopdonglaodong();
    gettaphuannghiepvu();
  }, []);
  return (
    <div style={{ height: 550, overflowY: "auto" }}>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Họ tên"
                variant="outlined"
                size="small"
                value={hoten}
                onChange={(event) => {
                  setHoten(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày tháng năm sinh"
                  value={ngaysinh}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaysinh(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={sodienthoai}
                onChange={(event) => {
                  setSodienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số CMND/CCCD"
                variant="outlined"
                size="small"
                value={cmnd}
                onChange={(event) => {
                  setCmnd(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp CMND/CCCD"
                  value={ngaycapcmnd}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaycapcmnd(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                size="small"
                value={diachi}
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              1. Giấy phép lái xe
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ height: 180, width: "100%", marginTop: 8 }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={giaypheplaixe}
                columns={gplxcolumn}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              2. Giấy khám sức khỏe
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ height: 180, width: "100%", marginTop: 8 }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={giaykhamsuckhoe}
                columns={gkskcolumn}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              3. Hợp đồng lao động
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ height: 180, width: "100%", marginTop: 8 }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={hopdong}
                columns={hdcolumn}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              4. GCN tập huấn nghiệp vụ vận tải
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ height: 180, width: "100%", marginTop: 8 }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={taphuannv}
                columns={thcolumn}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
              />
            </div>
          </GridItem>
        </GridContainer>
      </CardBody>
    </div>
  );
});

Capnhatlaixe.propTypes = {
  laixe_id: PropTypes.number,
};
export default Capnhatlaixe;
